import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Logo, HeaderNavigation, Image, StoreBadges, Phone } from '..';
import plate from '../../images/logo-icon.png';
import './HomeHeader.scss';

const imageQueries = graphql`
  query {
    phonePlaceholder: file(relativePath: { eq: "videos/iphone-video.jpg" }) {
      childImageSharp {
        fixed(width: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    headerImage: file(relativePath: { eq: "images/header-image.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 900) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export const HomeHeader = ({ title, content, phoneVideo, phoneVideoPlaceholder, siteName }) => {
  return (
    <StaticQuery
      query={imageQueries}
      render={({ phonePlaceholder, headerImage }) => (
        <header className="home-header">
          <div className="wrapper">
            <section className="home-header-top">
              <Logo />
              <HeaderNavigation />
            </section>
            <section className="home-header-body">
              <div className="home-header-content">
                <div className="home-header-content-title" dangerouslySetInnerHTML={{ __html: title.html }} />
                <div className="home-header-content-content" dangerouslySetInnerHTML={{ __html: content.html }} />
                <StoreBadges />
              </div>
              <Phone screen={phoneVideo.url} placeholder={phoneVideoPlaceholder} isVideo />
            </section>
            <img src={plate} className="logo-icon" alt={`${siteName} - Save up to 50%`} />
          </div>
          <div className="home-header-background">
            <Image image={{ localFile: headerImage }} />
          </div>
        </header>
      )}
    />
  );
};
